export default __webpack_public_path__ + "33a17c4770b7493f378cca553da1f8ae.svg";